import { ColorX } from 'framework/components/color/ColorX';
import { IOrderV2, OrderProcessStatus } from 'gen/ApiClient';
import { OrderProcessStatusToColorXRecord } from './OrderProcessStatusToColorXRecord';

export const mapOrderToColorX = (item: IOrderV2): ColorX => {
	return item.hasWarning ? 'warning' : OrderProcessStatusToColorXRecord[item.status as OrderProcessStatus];
};
